import { type PortableTextBlock } from '@portabletext/types';

import { type ArticleByIdQuery } from '../generated/content';

const mapArticleByIdToArticle = (
  articleById: ArticleByIdQuery['articleById'] | undefined
): {
  body: PortableTextBlock[];
  id: string;
  image: string | null;
  title: string;
} | null => {
  if (!articleById) return null;

  return {
    body: (articleById.body as PortableTextBlock[]) ?? [],
    id: articleById.id,
    image: articleById.image ?? null,
    title: articleById.title,
  };
};

export { mapArticleByIdToArticle };
